import React from "react";
import { useHistory } from "react-router-dom";
import Page from "../../../_components/Layout/Page";
import Modal from "../../../_components/Modal";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";
import Toast from "../../../_components/Toast";
import { createBranchPlan, getPlans } from "../../../api/plans";
import AppContext from "../context";
import { formatCurrencyValue, getCookieByName } from "../../../utils";
import styled, { css } from "styled-components";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingInput from "../../../_components/LoadingInput";

import * as colors from "../../../assets/_base/colors";
import IconButton from "../../../_components/IconButton";

import { supportPhoneNumber } from "../../../utils";

const branch = getCookieByName("branch_owner_id");

const Line = styled.hr`
  background-color: ${colors.lightBlue} !important;
  width: 20px;
  height: 1px;
  border-radius: 20px;
`;

const Divider = styled.hr`
  background-color: ${colors.lightCyan};
`;

const breakpoint = "800px";
const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: hidden;
  scroll-behavior: smooth;
  user-select: none;
  @media (max-width: ${breakpoint}) {
    flex-direction: column;
  }
`;

const Header = styled.div`
  background-color: ${colors.lightBlue};
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
`;

const Banner = styled.div`
  position: absolute;
  rotate: 30deg;
  top: 0;
  right: 0;
  margin-top: 30px;
  margin-right: -10px;
  padding-left: 10px;
  padding-right: 2px;
  padding-top: 3px;
  padding-bottom: 10px;
  background-color: ${colors.darkBlue};
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  display: none;
  ${(props) => {
    if (props.notes_quantity === 10) {
      return css`
        display: block;
      `;
    }
  }}
`;

const Inner = styled.div`
  padding: 10px;
`;

const Footer = styled.div`
  background-color: ${colors.lightBlue};
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  padding: 0;
  overflow: hidden;
`;

const Item = styled.div`
  flex: 0 0 auto;
  min-height: 400px !important;
  margin: 10px;
  border-radius: 30px;
  background: white;
  overflow: hidden;

  -webkit-box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);
  box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);

  ${(props) => {
    if (props.selected === true) {
      return css`
        border: 3px solid ${colors.success};
      `;
    }
    return css`
      border: 1px solid transparent;
    `;
  }}
`;

const Title = styled(Text)`
  padding-top: 10px;
  padding-bottom: 10px;
`;

const ToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 24px;
  gap: 12px;
  padding: 0 12px;
`;

const ToggleSwitchButton = styled.button`
  --pad: 4px;
  --bg: ${colors.lightCyan};
  --accent: ${colors.lightBlue};

  display: block;
  position: relative;
  border: 1px solid var(--accent);
  background: transparent;
  border-radius: 999px;
  padding: var(--pad);
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  min-width: 320px;
  width: min(560px, 85%);
  box-shadow: 0 3px 10px rgba(0,0,0,0.06);
  transition: box-shadow 0.18s ease;

  &:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.10); }
  &:focus { outline: none; box-shadow: 0 0 0 3px rgba(0,123,255,0.12); }

  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`;

const ToggleLabel = styled.span`
  z-index: 3;
  text-align: center;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 12px;
  color: ${(p) => (p.active ? "white" : colors.lightBlue)};
  transition: color 0.18s ease;
  pointer-events: none;
`;

const ToggleSlider = styled.span`
  position: absolute;
  z-index: 2;
  top: calc(var(--pad));
  left: calc(var(--pad));
  width: calc(50% - calc(var(--pad)));
  height: calc(100% - calc(var(--pad) * 2));
  background: ${colors.lightBlue};
  border-radius: 999px;
  transition: transform 0.22s cubic-bezier(.2,.9,.2,1), width 0.18s;
  transform: ${(p) => (p.active ? "translateX(100%)" : "translateX(0)")};
  box-shadow: 0 6px 16px rgba(14, 122, 255, 0.18);
  will-change: transform;
`;


const PayMethodRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 14px 6px 14px;
`;

const PayMethodGroup = styled.div`
  display: flex;
  width: 100%;
  background: white;
  border: 2px solid ${colors.lightBlue};
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  overflow: hidden;
`;

const PayMethodPill = styled.button`
  flex: 1;
  min-height: 52px;
  border: 0;
  padding: 14px 12px;
  font-size: 0.95em;
  font-weight: 700;
  cursor: pointer;
  background: ${(p) => (p.active ? colors.lightBlue : "white")};
  color: ${(p) => (p.active ? "white" : colors.lightBlue)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.lightBlue};
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

const PayMethodDivider = styled.div`
  width: 2px;
  background: ${colors.lightBlue};
  flex-shrink: 0;
`;

const PriceBox = styled.div`
  margin: 8px 14px 10px 14px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid ${colors.lightCyan};
  background: white;
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 6px 0;
`;

const PriceMain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 4px;

  .label {
    font-weight: 700;
  }

  .value {
    font-weight: 800;
    font-size: 1.1em;
  }
`;

const Muted = styled.span`
  opacity: 0.85;
`;

const MoreLessBtn = styled(Button)`
  padding: 0;
  margin-bottom: 10px;
`;

const MoreLessText = styled(Text)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;



// helper de arredondamento. colocar no utils depois
function toCents(value) {
  if (value === null || value === undefined) return 0
  const s0 = String(value).trim().replace(/\s/g, "").replace(",", ".")
  const neg = s0.startsWith("-")
  const s = neg ? s0.slice(1) : s0

  const [i, f = ""] = s.split(".")
  const intPart = parseInt(i || "0", 10)
  const fracPart = parseInt((f + "00").slice(0, 2), 10)

  const cents = intPart * 100 + (isNaN(fracPart) ? 0 : fracPart)
  return neg ? -cents : cents
}

function roundHalfEven(numerator, denominator) {
  const q = Math.trunc(numerator / denominator)
  const r = numerator % denominator

  const absR = Math.abs(r)
  const absD = Math.abs(denominator)
  const sign = numerator * denominator >= 0 ? 1 : -1

  const twiceR = absR * 2

  if (twiceR < absD) return q
  if (twiceR > absD) return q + sign

  return q % 2 === 0 ? q : q + sign
}

function calcDiscountCents(priceCents, period, payableWith) {
  if (payableWith !== "credit_card") return 0;

  if (period === "month") {
    return roundHalfEven(priceCents * 5, 100);
  }

  if (period === "year") {
    return roundHalfEven(priceCents * 2, 12);
  }

  return 0;
}



const AutoScrollComponent = ({
  items,
  onClick,
  payableWithByPlanId,
  onChangePayableWith,
}) => {
  const containerRef = React.useRef(null)
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [selected, setSelected] = React.useState("");
  const [isHovered, setIsHovered] = React.useState(false);
  const [expanded, setExpanded] = React.useState("");

  const onDragStart = (e) => {
    setIsDragging(true);
    setStartX(e.pageX + containerRef.current.scrollLeft);
    containerRef.current.style.scrollBehavior = "auto";
  };

  const onDragEnd = () => {
    setIsDragging(false);
    setIsHovered(false);
    containerRef.current.style.scrollBehavior = "smooth";
  };

  const onDragMove = (e) => {
    if (isDragging) {
      const moveX = startX - (e.pageX + containerRef.current.scrollLeft);
      containerRef.current.scrollLeft += moveX;
      setStartX(e.pageX + containerRef.current.scrollLeft);
    }
  };

  const onItemClick = (item) => {
    setSelected(selected === item.id ? "" : item.id);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (containerRef.current && !isDragging && !selected && !isHovered) {
        const scrollWidth = containerRef.current.scrollWidth;
        const clientWidth = containerRef.current.clientWidth;
        const scrollLeft = containerRef.current.scrollLeft;
        if (scrollLeft + clientWidth >= scrollWidth) {
          containerRef.current.scrollTo({ left: 0 });
        } else {
          containerRef.current.scrollTo({ left: scrollLeft + clientWidth });
        }
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [isDragging, isHovered, selected]);

  return (
    <div>
      <div className="row justify-content-between">
        <i
          className="fas fa-arrow-left"
          style={{ fontSize: 25, cursor: "pointer" }}
          onClick={() => {
            containerRef.current.scrollTo({ left: 0 });
          }}
        />
        <i
          className="fas fa-arrow-right"
          style={{ fontSize: 25, cursor: "pointer" }}
          onClick={() => {
            containerRef.current.scrollTo({ left: 1421 });
          }}
        />
      </div>

      <ScrollContainer
        ref={containerRef}
        onMouseDown={onDragStart}
        onMouseMove={onDragMove}
        onMouseLeave={onDragEnd}
        onMouseUp={onDragEnd}
        onMouseEnter={handleMouseEnter}
      >
        {items.map((item) => (
          <Column xs="12" md="6" lg="4" xl="3" key={item.id}>
            <Item selected={item.id === selected} planId={item.id}>
              <Header color="primary" plan={item.id}>
                <Title fontSize="md" align="center" color="white">
                  {item.name}
                </Title>
                <Banner notes_quantity={item.notes_quantity}>
                  <Text fontSize="1.1em" color="white">
                    Mais vendido!
                  </Text>
                </Banner>
              </Header>

              {item.id === "89723c2c-64d1-40b4-9806-1aa433f91645" ||
                item.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
                <Text align="center">
                  * Você tem até um ano ou até vencer o seu certificado digital
                  para utilizá-las
                </Text>
              ) : (
                <Text></Text>
              )}

              <Inner onClick={() => setExpanded(expanded === item.id ? "" : item.id)}>
                {item.description
                  .split(";")
                  .slice(0, 2)
                  .map((description) => {
                    const [desc, allow] = description.split("=");
                    return (
                      <React.Fragment key={desc}>
                        <Text fontSize="1.1em" color="primary">
                          <i
                            className={`fas fa-${allow === "S" ? "check" : "ban text-danger"
                              }`}
                          ></i>{" "}
                          {desc}
                        </Text>
                        <Divider />
                      </React.Fragment>
                    );
                  })}

                {expanded === item.id &&
                  item.description
                    .split(";")
                    .slice(2)
                    .map((description) => {
                      const [desc, allow] = description.split("=");
                      return (
                        <React.Fragment key={desc}>
                          <Text fontSize="1.1em" color="primary">
                            <i
                              className={`fas fa-${allow === "S" ? "check" : "ban text-danger"
                                }`}
                            ></i>{" "}
                            {desc}
                          </Text>
                          <Divider />
                        </React.Fragment>
                      );
                    })}

                <MoreLessBtn
                  as="text"
                  onClick={() => setExpanded(expanded === item.id ? "" : item.id)}
                  style={{ padding: 0, marginBottom: 10 }}
                >
                  <MoreLessText fontSize="sm" color="primary" align="center">
                    {expanded === item.id ? "Ver menos" : "Ver mais"}
                    <i
                      className={`fas fa-chevron-${expanded === item.id ? "up" : "down"
                        }`}
                      style={{ fontSize: 12 }}
                    />
                  </MoreLessText>
                </MoreLessBtn>

                {item.id === "89723c2c-64d1-40b4-9806-1aa433f91645" ||
                  item.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
                  <Text align="center">
                    RENOVANDO SEU CERTIFICADO CONOSCO, VOCÊ TERÁ MAIS NOTAS POR
                    MAIS UM ANO.
                  </Text>
                ) : (
                  <Text align="center">
                    NÃO INCLUI CERTIFICADO DIGITAL (A1) GRÁTIS
                  </Text>
                )}
              </Inner>

              {!item.free_plan &&
                item.id !== "7945dc1a-1722-43db-a92c-59c8c23346e9" &&
                (() => {
                  const isAnnual = (item.iugu_id || "").startsWith("anual");
                  const period = isAnnual ? "year" : "month";

                  const payableWith =
                    payableWithByPlanId[item.id];

                  const priceCents = toCents(item.price);
                  const discountCents = calcDiscountCents(
                    priceCents,
                    period,
                    payableWith
                  );
                  const totalCents = Math.max(priceCents - discountCents, 0);

                  return (
                    <React.Fragment>


                      <PriceBox
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <PriceMain>
                          <Text color="primary" className="label">
                            Total:
                          </Text>
                          <Text color="primary" className="value">
                            {formatCurrencyValue(totalCents / 100)}
                            {isAnnual ? "/ano" : "/mês"}
                          </Text>
                        </PriceMain>

                        {isAnnual && (() => {




                          const monthlyEquivalentCents = roundHalfEven(totalCents, 12)

                          return (

                            <Text
                              fontSize="xs"
                              color="primary"
                              align="center"
                              style={{ marginTop: 4, opacity: 0.85 }}
                            >
                              <Divider />
                              Equivalente a{" "}
                              <strong>
                                {formatCurrencyValue(monthlyEquivalentCents / 100)}/mês
                              </strong>
                            </Text>
                          )
                        })()}
                      </PriceBox>

                    </React.Fragment>
                  );
                })()}

              <Footer plan={item.id} color="primary">
                {selected === item.id && !item.free_plan && item.id !== "7945dc1a-1722-43db-a92c-59c8c23346e9" ? (
                  <PayMethodGroup>
                    <PayMethodPill
                      type="button"
                      active={(payableWithByPlanId[item.id]) === "credit_card"}
                      onClick={() => {
                        onChangePayableWith(item.id, "credit_card");
                        onClick(item);
                      }}
                    >
                      <i className="fas fa-credit-card" />
                      Cartão -5%
                    </PayMethodPill>

                    <PayMethodDivider />

                    <PayMethodPill
                      type="button"
                      active={(payableWithByPlanId[item.id]) === "pix"}
                      onClick={() => {
                        onChangePayableWith(item.id, "pix");
                        onClick(item);
                      }}
                    >
                      <i className="fas fa-qrcode" />
                      PIX
                    </PayMethodPill>
                  </PayMethodGroup>
                ) : (
                  <div className="d-flex justify-content-center py-2">
                    <Button as="text" onClick={() => {
                      if (item.free_plan || item.id === "7945dc1a-1722-43db-a92c-59c8c23346e9") {
                        onClick(item);
                      } else {
                        setSelected(item.id);
                      }
                    }}>
                      {item.id === "7945dc1a-1722-43db-a92c-59c8c23346e9" ? (
                        <Text fontSize="md" color="white" align="center">
                          Negociar com um consultor
                        </Text>
                      ) : item.free_plan === true ? (
                        <Text fontSize="md" color="white" align="center">
                          Adquirir gratuitamente
                        </Text>
                      ) : (
                        <Text fontSize="md" color="white" align="center">
                          Escolher plano
                        </Text>
                      )}
                    </Button>
                  </div>
                )}
              </Footer>
            </Item>
          </Column>
        ))}
      </ScrollContainer>
    </div>
  );
};

export default (props) => {
  const ref = React.useRef(null);
  const history = useHistory();
  const context = React.useContext(AppContext);
  const [showModalInfo, setShowModalInfo] = React.useState(true);
  const [plans, setPlans] = React.useState([]);
  const [selectedPlan, setSelectedPlan] = React.useState({});

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [toast, setToast] = React.useState({
    show: false,
    message: "",
    type: "",
  });

  const [planType, setPlanType] = React.useState("mensal");
  const [payableWithByPlanId, setPayableWithByPlanId] = React.useState({});

  function onChangePayableWith(planId, value) {
    setPayableWithByPlanId((prev) => ({ ...prev, [planId]: value }));
  }

  function openModalSelectPlan(plan) {
    const isNegotiation = plan.id === "7945dc1a-1722-43db-a92c-59c8c23346e9";
    if (isNegotiation) {
      window.open(
        `https://wa.me/${supportPhoneNumber}?text=Olá!,+quero+negociar+um+plano+entre+31+e+99+notas+no+Easygestor`,
        "_blank"
      );
      return;
    }
    setSelectedPlan(plan);
  }

  function closeModalSelectPlan() {
    if (loading) {
      return;
    }
    setSelectedPlan({});
  }

  function getModalTotal(plan) {
    if (!plan || !plan.id) return { totalText: "", suffix: "" };

    const isAnnual = ((plan.iugu_id || "").startsWith("anual"));
    const period = isAnnual ? "year" : "month";
    const suffix = isAnnual ? "/ano" : "/mês";

    const payableWith = payableWithByPlanId[plan.id];

    const priceCents = toCents(plan.price);
    const discountCents = calcDiscountCents(priceCents, period, payableWith);
    const totalCents = Math.max(priceCents - discountCents, 0);

    return {
      totalText: formatCurrencyValue(totalCents / 100),
      suffix,
      payableWith,
    };
  }

  function onCreate() {
    setLoading(true);
    setToast({});

    const isAnnual = ((selectedPlan.iugu_id || "").startsWith("anual"));
    const period = isAnnual ? "year" : "month";
    const payable_with = payableWithByPlanId[selectedPlan.id];

    createBranchPlan({ plan: selectedPlan.id, payable_with, period })
      .then((resp) => {
        let updatedBranch = JSON.parse(
          localStorage.getItem("easygestorweb_current_branch") || "{}"
        );
        updatedBranch["branch_plan"] = resp;
        updatedBranch["branch_plan"]["is_fiscal"] = true;

        window.localStorage.setItem(
          "easygestorweb_current_branch",
          JSON.stringify(updatedBranch)
        );

        setSelectedPlan(resp)
        setSuccess(true)
        setLoading(false)
      })

      .catch((error) => {
        setLoading(false);
        if (error.response) {
        }
        if (error.iugu_error) {
          setToast({
            show: true,
            message: `Não foi possível criar sua assinatura. Erro: ${error.iugu_error}`,
            type: "error",
          });
        }
        if (error.partner_error) {
          setToast({
            show: true,
            message: `Não foi possível criar sua assinatura. Erro: ${error.partner_error}`,
            type: "error",
          });
        }
        if (error.invoice_pending) {
          setToast({
            show: true,
            message: (
              <div>
                Você possui faturas pendentes, para consultar suas faturas,
                clique no botão abaixo.
                <a className="btn btn-primary" href={"/plan/branch-invoices"}>
                  Vizualizar faturas
                </a>
              </div>
            ),
            type: "error",
          });
        }
        if (error.plan_error) {
          setToast({
            show: true,
            message: (
              <div>
                Sua empresa não possui mais créditos para assinatura gratuita.
                Escolha outro plano ou fale com o suporte.{" "}
                <a
                  className="btn btn-primary text-center"
                  target="_blank"
                  href={`https://api.whatsapp.com/send?phone=+${supportPhoneNumber}&text=Ol%C3%A1.%20Minha%20empresa%20n%C3%A3o%20possui%20mais%20cr%C3%A9ditos%20para%20assinatura%20gratuita.%20Preciso%20de%20ajuda.`}
                  rel="noreferrer"
                >
                  Solicitar suporte
                </a>
              </div>
            ),
            type: "error",
          });
        }
      });
  }

  function onFinalize() {
    let href = "";
    if (selectedPlan.free_plan == true) {
      href = "/digital-certificate";
    } else {
      href = "/plan/branch-invoices";
    }

    window.location.href = href;
  }

  function init() {
    const branchId = getCookieByName("branch_owner_id");

    if (!branchId || branchId === "09ef7488-d439-40da-b384-5ccde14ffe8a") {
      history.push("/branches/create");
    } else {
      getPlans().then((pls) => setPlans(pls));
    }
  }
  React.useEffect(init, [ref.current, context.currentBranch]);

  const filteredPlans = plans.filter((p) => {
    const isAnnual = ((p.iugu_id || "").startsWith("anual"));
    if (planType === "anual") {
      return isAnnual;
    }
    return !isAnnual;
  });

  const modalTotal = getModalTotal(selectedPlan);

  return (
    <Page ref={ref}>
      <Row>
        <Column col="12">
          <Text fontSize="lg" align="center" color="primary">
            Escolha seu Plano Ideal
          </Text>
        </Column>
      </Row>

      <ToggleContainer>
        <ToggleSwitchButton
          type="button"
          role="switch"
          aria-checked={planType === "anual"}
          onClick={() => setPlanType(planType === "mensal" ? "anual" : "mensal")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setPlanType(planType === "mensal" ? "anual" : "mensal");
            }
          }}
        >
          <ToggleLabel active={planType === "mensal"}>
            Mensal com 5% de desconto!
          </ToggleLabel>

          <ToggleLabel active={planType === "anual"}>
            Anual com 2 meses grátis!
          </ToggleLabel>

          <ToggleSlider active={planType === "anual"} />
        </ToggleSwitchButton>
      </ToggleContainer>


      <AutoScrollComponent
        onClick={openModalSelectPlan}
        items={filteredPlans}
        payableWithByPlanId={payableWithByPlanId}
        onChangePayableWith={onChangePayableWith}
      />

      <Modal
        title={`Assinatura ${selectedPlan.name}`}
        show={!!selectedPlan.id && !success}
        onHide={closeModalSelectPlan}
      >
        {selectedPlan.id === "89723c2c-64d1-40b4-9806-1aa433f91645" ||
          selectedPlan.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
          <Text color="primary" fontSize="md" className="py-3">
            Prezado(a) cliente, você está prestes a adquirir o plano{" "}
            {selectedPlan.name} para sua empresa.
          </Text>
        ) : (
          <React.Fragment>
            <Text color="primary" fontSize="md">
              Prezado(a) cliente, você está prestes a adquirir o plano{" "}
              {selectedPlan.name} para sua empresa no valor de{" "}
              <strong>
                {modalTotal.totalText}
                {modalTotal.suffix}
              </strong>
              .
            </Text>
            <Text className="py-4" color="danger" fontSize="md">
              Atenção! Após confirmação, não será mais possível realizar emissão
              de notas enquanto o novo plano estiver com a fatura pendente. Após
              pagamento, a ativação será liberada automaticamente.
            </Text>
            <Text className="mb-2" color="primary">
              Forma de pagamento selecionada:{" "}
              <strong>
                {modalTotal.payableWith
                  ? (modalTotal.payableWith === "pix"
                    ? "PIX"
                    : "Cartão de crédito")
                  : "Nenhuma selecionada"}
              </strong>
            </Text>
          </React.Fragment>
        )}

        <Text align="center" color="primary" fontSize="md">
          Clique no botão abaixo para confirmar a assinatura.
        </Text>

        {!selectedPlan.free_plan && (
          <React.Fragment>
            <PayMethodRow>
              <PayMethodGroup>
                <PayMethodPill
                  type="button"
                  active={(payableWithByPlanId[selectedPlan.id]) === "credit_card"}
                  onClick={() => onChangePayableWith(selectedPlan.id, "credit_card")}
                >
                  <i className="fas fa-credit-card" />
                  Cartão -5%
                </PayMethodPill>

                <PayMethodDivider />

                <PayMethodPill
                  type="button"
                  active={(payableWithByPlanId[selectedPlan.id]) === "pix"}
                  onClick={() => onChangePayableWith(selectedPlan.id, "pix")}
                >
                  <i className="fas fa-qrcode" />
                  PIX
                </PayMethodPill>
              </PayMethodGroup>
            </PayMethodRow>
          </React.Fragment>
        )}

        <div className="d-flex justify-content-center pt-5">
          <Button
            disabled={loading || (!selectedPlan.free_plan && !payableWithByPlanId[selectedPlan.id])}
            onClick={onCreate}
            style={{
              backgroundColor:
                colors.lightBlue
            }}
          >
            {loading ? (
              <span className="d-inline-flex align-items-center" style={{ gap: 10 }}>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Criando assinatura, por favor aguarde...
              </span>
            ) : (
              "Confirmar"
            )}
          </Button>
        </div>
      </Modal>

      <SweetAlert
        show={false}
        type={"info"}
        showCancel={false}
        showConfirm={false}
        onCancel={null}
        onConfirm={null}
        title={
          <div>
            <div className="h2 text-danger">Importante</div>
          </div>
        }
      >

        <div style={{ textAlign: 'left', color: '#545151' }}>

          <p>
            Nos estados de <strong style={{ color: '#545151', fontWeight: 'bold' }}>AL e PA e RJ, o MEI</strong> não é permitido a emitir NF-e (nota fiscal de produto).
            Mas caso você seja <strong style={{ color: '#545151', fontWeight: 'bold' }}>MEI</strong> no estado do <strong style={{ color: '#545151', fontWeight: 'bold' }}>Rio de Janeiro</strong>,
            você <strong style={{ color: '#545151', fontWeight: 'bold' }}>pode realizar a emissão de NFC-e</strong> (cupom fiscal), desde que seja gerado o código CSC.
          </p>

          <p>
            Nos estados de <strong style={{ color: '#545151', fontWeight: 'bold' }}>MG e RS</strong>, existem particularidades para liberação da emissão de
            <strong style={{ color: '#545151', fontWeight: 'bold' }}> NF-e para quem é MEI</strong>.
          </p>

          <p>
            <a href={`https://wa.me/${supportPhoneNumber}?`} target="_blank" style={{ color: '#5e17eb', textDecoration: 'underline' }}>
              Verifique com o nosso Suporte técnico.
            </a>
          </p>

          <p><strong style={{ color: '#545151', fontWeight: 'bold' }}>Requisitos mínimos para emissão de NF-e no Easygestor:</strong></p>
          <ul>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Inscrição Estadual</strong> (
              <a href="https://www.youtube.com/watch?v=KTHdFrTi380" target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}>
                Tudo sobre inscrição Estadual
              </a>
              );
            </li>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Certificado Digital modelo A1</strong> (
              <a href="http://bit.ly/comprar-certificad-eg-web-up" target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}>
                Oferta com desconto
              </a>
              );
            </li>
            <li>
              Caso você possua Certificado A3,
              <a href={`https://wa.me/${supportPhoneNumber}?`} target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}> fale com o suporte técnico</a>;
            </li>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Credenciamento na SEFAZ</strong> do seu estado.
            </li>
          </ul>

        </div>

        <div className="d-flex justify-content-center">
          <div>
            <Line />

            <IconButton onClick={() => setShowModalInfo(false)} icon="times text-danger" />

          </div>
        </div>

      </SweetAlert>

      <Modal title="Assinatura criada!" show={success} onHide={() => setSuccess(false)}>

        <Text color="primary" align="center" fontSize="md">
          Prezado(a) cliente, seja bem-vindo(a) ao Easygestor!
        </Text>
        {selectedPlan.id === "89723c2c-64d1-40b4-9806-1aa433f91645" || selectedPlan.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
          <React.Fragment>
            <Text color="primary" className="py-2" fontSize="md">
              Seu plano gratuito foi criado com sucesso! E você acabou de
              adquirir gratuitamente a emissão de {selectedPlan.notes_quantity}{" "}
              notas fiscais.
            </Text>
            <Text color="primary" className="py-2" fontSize="md">
              Você tem até um ano ou até vencer o seu certificado digital para
              utilizá-las.
            </Text>
            <Text color="primary" className="py-2" fontSize="md">
              Renovando seu certificado através você terá mais{" "}
              {selectedPlan.notes_quantity} notas por mais um ano.
            </Text>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Text color="primary" fontSize="md" className="py-2">
              Informamos que, o cancelamento da sua assinatura será deferido, se
              somente, não existir nenhuma pendência no nosso sistema
              financeiro.
            </Text>
            <Text color="primary" fontSize="md" className="py-2">
              Informamos também que, o simples fato de parar de pagar/usa o
              Sistema, o mesmo não anula cobranças em atraso pendentes, nem gera
              o cancelamento automático do seu Plano mensal de assinatura.
            </Text>
            <Text color="primary" fontSize="md" className="py-2">
              Em caso de dúvidas, ou para regularizar seu Plano, pedimos por
              gentileza que entre em contato com o nosso suporte técnico.
            </Text>
          </React.Fragment>
        )}
        <div className="d-flex justify-content-center pt-5">
          <Button onClick={onFinalize}>
            Declaro que li e concordo com o texto acima.
          </Button>
        </div>

      </Modal>

      <Toast show={toast.show} message={toast.message} type={toast.type} />
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/index.jsx